{
  "titles": {
    "deviations": {
      "interestRate": "Afwijkende rente aanvraag",
      "durationInMonths": "Afwijkende looptijd aanvraag"
    }
  },
  "fields": {
    "labels": {
      "deviations": {
        "interestRate": {
          "value": "Rentevoorstel",
          "explanation": "Toelichting"
        },
        "durationInMonths": {
          "value": "Looptijd voorstel",
          "explanation": "Toelichting"
        }
      },
      "referenceNumber": "Contractnummer",
      "startDate": "Startdatum",
      "endDate": "Einddatum",
      "variant": "Variant",
      "amount": "Inleg",
      "interestRate": "Rente",
      "durationInMonths": "Looptijd",
      "period": "Contractperiode",
      "monthlyInterest": "Maandrente"
    }
  },
  "messages":{
    "deviateReject": "Tegenvoorstel indienen"
  },
  "actions": {
    "deviationApproved": "Afwijking akkoord",
    "deviationRejected": "Nieuw voorstel"
  }
}
